import { render, staticRenderFns } from "./border.vue?vue&type=template&id=2a70f59c&scoped=true&"
import script from "./border.vue?vue&type=script&lang=js&"
export * from "./border.vue?vue&type=script&lang=js&"
import style0 from "./border.vue?vue&type=style&index=0&id=2a70f59c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a70f59c",
  null
  
)

export default component.exports